const STICKY_OFFSET = 30;

const stickyAside = {
  _selector: '.single-product-content__aside-inner',
  _property: '--sticky-aside-top',
  _element: null,

  init() {
    this._element = document.querySelector(this._selector);

    if (!this._element) {
      return;
    }

    this._update = this._update.bind(this);

    if ('ResizeObserver' in window) {
      new ResizeObserver(this._update).observe(this._element);
    }

    window.addEventListener('resize', this._update);
    this._update();
  },

  _update() {
    const overflow =
      this._element.offsetHeight + (STICKY_OFFSET * 2) - window.innerHeight;
    const top = overflow > 0 ? STICKY_OFFSET - overflow : STICKY_OFFSET;

    this._element.style.setProperty(this._property, `${top}px`);
  },
};

export default stickyAside;



// WEBPACK FOOTER //
// ./scripts/global/sticky-aside.js